import { useEffect, useState, useRef } from "react";
import "./Logs.css";
import { toast } from "react-toastify";
import Sidebarnew from "./NewUI/Sidebarnew";
import Navigationnew from "./NewUI/Navigationnew";
function Logs() {
  // ✅ ALL STATE UNCHANGED
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLog, setSelectedLog] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchText, setSearchText] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const totalPages = Math.ceil(logs.length / rowsPerPage);
  const currentLogs = logs.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const hasFetched = useRef(false);

  // ✅ ALL FETCH LOGIC UNCHANGED
  const fetchLogs = async (from = "", to = "", search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      let url = `${process.env.REACT_APP_API_BASE_URL}/audit-logs`;
      const params = new URLSearchParams();
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      if (search) params.append("search", search);
      if (params.toString()) url += `?${params.toString()}`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to fetch logs");
      const data = await response.json();
      setLogs(data);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchLogs();
  }, []);

useEffect(() => {
    if (!hasFetched.current) return; // Skips the initial mount to prevent double-fetching
    
    setCurrentPage(1);
    fetchLogs(fromDate, toDate, searchText);
  }, [fromDate, toDate, searchText]); // 🔥 Added searchText here to trigger on every keystroke

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  // ✅ UNCHANGED
  const handleViewDetails = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/audit-logs/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Failed to fetch log details");
      const data = await response.json();
      setSelectedLog(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching details:", error);
   toast.error("Unable to load log details");
    }
  };

  // ✅ UNCHANGED
  const downloadFile = async (format) => {
    try {
      const token = localStorage.getItem("token");
      let url = `${process.env.REACT_APP_API_BASE_URL}/audit-logs/export?format=${format}`;
      if (fromDate) url += `&from=${fromDate}`;
      if (toDate) url += `&to=${toDate}`;
      if (searchText) url += `&search=${searchText}`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Download failed");
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      if (format === "csv") link.download = "audit-logs.csv";
      if (format === "pdf") link.download = "audit-logs.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error(err);
   toast.error("Download failed");
    }
  };

  // ✅ UNCHANGED
  const getActionBadgeClass = (action) => {
    if (!action) return "badge-default";
    switch (action.toUpperCase()) {
      case "INSERT": return "badge-insert";
      case "UPDATE": return "badge-update";
      case "DELETE": return "badge-delete";
      default: return "badge-default";
    }
  };

  // ✅ UNCHANGED
  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.split(" ");
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };

return (
  <>
    <div className="db-page-layout">

      <aside className="db-sidebar-shell">
        <Sidebarnew />
      </aside>

      <div className="db-main-wrapper">

        <div className="db-topbar-shell">
          <Navigationnew
            setArtifactsOpen={() => {}}
            artifactsOpen={false}
          />
        </div>

        <div className="logs-wrap">
          <div className="logs-page-header">
    <h1 className="logs-page-title">Logs</h1>
    <p className="logs-page-description">System and agent activity logs</p>
  </div>

        {/* ── TOP BAR ── */}
        <div className="logs-topbar">
          {/* <div className="logs-topbar-left">
            <h5 className="logs-title">Logs</h5>
            <p className="logs-subtitle">System and agent activity log</p>
          </div> */}
          <div className="dropdown">
            <button
              className="logs-download-btn"
              data-bs-toggle="dropdown"
            >
              <i className="bi bi-download" />
              Download
            </button>
            <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0">
              <li>
                <button className="dropdown-item py-2" onClick={() => downloadFile("csv")}>
                  Download CSV
                </button>
              </li>
              <li>
                <button className="dropdown-item py-2" onClick={() => downloadFile("pdf")}>
                  Download PDF
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* ── FILTER BAR ── */}
        <div className="logs-filter-bar">
          {/* Search */}
          <div className="logs-search-wrap">
            <i className="bi bi-search logs-search-icon" />
          <input
  type="text"
  className="logs-search-input"
  placeholder="Search logs..."
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)} // 🔥 Now triggers the useEffect above instantly
/>
          </div>

          {/* Date range */}
          <div className="logs-date-wrap">
            <span className="logs-date-label">Date</span>
            <input
              type="date"
              className="logs-date-input"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <span className="logs-date-label">to</span>
            <input
              type="date"
              className="logs-date-input"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>

        {/* ── TABLE CARD ── */}
        <div className="logs-table-card">
          <table className="logs-table">
            <thead>
              <tr>
                <th>USER</th>
                <th>Table</th>
                <th>ACTION</th>
                <th>TIME STAMP</th>
                <th className="logs-th-center">VIEW</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="logs-empty">
                    <div className="spinner-border spinner-border-sm me-2" role="status" />
                    Loading...
                  </td>
                </tr>
              ) : logs.length > 0 ? (
               currentLogs.map((log) => (
  <tr
    key={log.id}
    onClick={() => handleViewDetails(log.id)}
    style={{ cursor: "pointer" }}
  >
    <td>
      <div className="logs-user-cell">
        <div className="logs-avatar">
          {getInitials(log.user_name)}
        </div>
        <span className="logs-username">
          {log.user_name || "UNKNOWN"}
        </span>
      </div>
    </td>

    <td className="logs-doc-cell">
      {log.table_name?.replace(/_/g, " ") || "AGENT DOCUMENT"}
    </td>

    <td>
      <span
        className={`logs-action-badge ${getActionBadgeClass(
          log.action_type
        )}`}
      >
        {log.action_type}
      </span>
    </td>

    <td className="logs-time-cell">
      {log.created_at
        ? new Date(log.created_at).toLocaleString("en-US")
        : ""}
    </td>

    <td className="logs-th-center">
      <button
        className="logs-view-btn"
        onClick={(e) => {
          e.stopPropagation();
          handleViewDetails(log.id);
        }}
      >
        VIEW
      </button>
    </td>
  </tr>
))
              ) : (
                <tr>
                  <td colSpan="5" className="logs-empty">No logs found</td>
                </tr>
              )}
            </tbody>
          </table>
{/* ── PAGINATION FOOTER ── */}
<div className="logs-pagination">
  <span className="logs-pagination-info">
    Showing rows{" "}
    {logs.length > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0}–
    {Math.min(currentPage * rowsPerPage, logs.length)} of {logs.length}
  </span>

  {/* 🔥 Added limit selector + arrows wrapper */}
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    
    {/* Rows per page selector */}
    <select
      value={rowsPerPage}
      onChange={(e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
      }}
      style={{
        height: "28px",
        fontSize: "12px",
        borderRadius: "4px",
        padding: "2px 6px",
        border: "1px solid #ccc",
        background: "#fff",
        cursor: "pointer"
      }}
    >
      <option value={10}>10</option>
      <option value={20}>20</option>
      <option value={30}>30</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>

    {/* Existing arrows */}
    <div className="logs-pagination-arrows">
      <button
        className="logs-page-arrow"
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((p) => p - 1)}
      >
        <i className="bi bi-chevron-left" />
      </button>
      <button
        className="logs-page-arrow"
        disabled={currentPage === totalPages || totalPages === 0}
        onClick={() => setCurrentPage((p) => p + 1)}
      >
        <i className="bi bi-chevron-right" />
      </button>
    </div>

  </div>
</div>
</div>
</div>
</div>
</div>


{/* ── MODAL ── */}
{showModal && selectedLog && (
  <div className="logs-modal-overlay" onClick={() => setShowModal(false)}>
    <div
      className="logs-modal"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close button */}
      <button
        className="logs-modal-close"
        onClick={() => setShowModal(false)}
      >
        <i className="bi bi-x" />
      </button>

      <h4 className="logs-modal-title">Log Detail</h4>

      <div className="logs-modal-body">
        <div className="logs-detail-row">
          <span className="logs-detail-label">User</span>
          <span className="logs-detail-colon">:</span>
          <span className="logs-detail-value">{selectedLog?.user_name}</span>
        </div>

        <div className="logs-detail-row">
          <span className="logs-detail-label">Action</span>
          <span className="logs-detail-colon">:</span>
          <span className="logs-detail-value">
            <span className={`logs-action-badge ${getActionBadgeClass(selectedLog?.action_type)}`}>
              {selectedLog?.action_type}
            </span>
          </span>
        </div>

        <div className="logs-detail-row">
          <span className="logs-detail-label">Email</span>
          <span className="logs-detail-colon">:</span>
          <span className="logs-detail-value">
            <a href={`mailto:${selectedLog?.user_email}`} className="logs-email-link">
              {selectedLog?.user_email}
            </a>
          </span>
        </div>

        <div className="logs-detail-row">
          <span className="logs-detail-label">Time</span>
          <span className="logs-detail-colon">:</span>
          <span className="logs-detail-value">
            {selectedLog?.created_at
              ? new Date(selectedLog.created_at).toLocaleString("en-US", {
                  day: "2-digit", month: "2-digit", year: "numeric",
                  hour: "numeric", minute: "2-digit", hour12: true,
                })
              : ""}
          </span>
        </div>

        <div className="logs-detail-row">
          <span className="logs-detail-label">Table</span>
          <span className="logs-detail-colon">:</span>
          <span className="logs-detail-value">
            {selectedLog?.table_name?.replace(/_/g, " ")}
          </span>
        </div>

        <div className="logs-detail-row logs-detail-row--top">
          <span className="logs-detail-label">Old Data</span>
          <span className="logs-detail-colon">:</span>
          <pre className="logs-data-box">
            {Object.keys(selectedLog?.old_data || {}).length > 0
              ? JSON.stringify(selectedLog?.old_data, null, 2)
              : ""}
          </pre>
        </div>

        <div className="logs-detail-row logs-detail-row--top">
          <span className="logs-detail-label">New Data</span>
          <span className="logs-detail-colon">:</span>
          <pre className="logs-data-box">
            {Object.keys(selectedLog?.new_data || {}).length > 0
              ? JSON.stringify(selectedLog?.new_data, null, 2)
              : ""}
          </pre>
        </div>
      </div>
    </div>
  </div>
)}
</>
);
}

export default Logs;